import React from 'react';
import { connect } from 'react-redux';
import { IEventV2 } from '../../../../data/entities/event';
import { IEventNote } from '../../../../data/entities/event/event-note';
import { queueEventNote } from '../../../../entities/event-notes/actions';
import { IThunkDispatch } from '../../../../store/middleware';
import { NewEventNoteComponent } from './NewEventNoteComponent';

interface INewEventNoteProps {
	expanded: boolean;
	event: IEventV2;
	setPending: (pending: boolean) => any;
	submitEventNote: (EventNotes: IEventNote, eventId: string) => void;
}

const mapDispatchToProps = (dispatch: IThunkDispatch) => ({
	submitEventNote: (EventNote: IEventNote, eventId: string) => dispatch(queueEventNote('add', EventNote, eventId))
});

const NewEventNoteContainer: React.FC<INewEventNoteProps> = (props) => {
	return <NewEventNoteComponent
		expanded={props.expanded}
		event={props.event}
		submitEventNote={(note: IEventNote, eventId: string) => {
			props.submitEventNote(note, eventId);
			props.setPending(true);
		}}
	/>;
};

export const NewEventNote = connect(null, mapDispatchToProps)(NewEventNoteContainer);
